import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import Animate from '../../../../components/Animate';
import dataModel from '../../../../models/DataModel';
import NewTask from './NewTask';

import './ProjectTasks.scss';

class NewProjectTasks extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = { setOriginalHeight: true, expanded: true };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.actionCableUpdate != this.props.actionCableUpdate) {
      this.setState({ actionCableUpdate: this.props.actionCableUpdate });
    }
  }

  createTaskCards(tasks, project) {
    this.totalHeight = 15;
    if (tasks.length) {
      return tasks.map(task => {
        let height = 65 + 19; // + ((Math.floor(task.name.length / 26) + 1) * 19)
        this.totalHeight += height + 2;
        return <NewTask project={project} task={task} key={task.id} height={height} />;
      });
    }
  }

  handleExpand() {
    if (!this.state.expanded) {
      this.setState({ expanded: true, animateExpand: true });
    }
  }

  handleContract() {
    if (this.state.expanded || this.state.setOriginalHeight) {
      this.setState({ animateContract: true });
    }
  }

  handleFinishAnimation() {
    if (this.state.expanded && this.state.animateContract) {
      this.setState({
        animateContract: false,
        expanded: false,
        setOriginalHeight: false,
      });
    }
    else {
      this.setState({ animateExpand: false, setOriginalHeight: false });
    }
  }

  checkForAssignedTasks() {
    const { project, appliedTaskFilters } = this.props;
    const viewTasks = project.tasks.filter(task => {
      if (!task) {
        return false;
      }
      if (!task.has_field_user && !task.has_approver && !task.has_reviewer) {
        return false;
      }
      if (appliedTaskFilters && appliedTaskFilters.length > 0) {
        return appliedTaskFilters.includes(task.status);
      }
      else {
        return true;
      }
    });
    return viewTasks.length > 0;
  }

  render() {
    if (!this.props.project) {
      return null;
    }
    const { project, viewTasks } = this.props;
    const { expanded, animateExpand, animateContract, setOriginalHeight } = this.state;
    let animator = null;
    let id = 'task-list-' + project.id;
    const taskList = this.createTaskCards(viewTasks, project);

    if (animateExpand) {
      let endVal = this.totalHeight ? this.totalHeight : 0;
      let exduration = 500;
      animator = <Animate component_id={id} key="animate_expand" property={{ height: { startVal: 0, endVal: endVal } }} completionCallback={this.handleFinishAnimation} duration={exduration} />;
    }
    else if (animateContract) {
      let conduration = 500;
      animator = <Animate component_id={id} key="animate_contract" property={{ height: { endVal: 0 } }} completionCallback={this.handleFinishAnimation} duration={conduration} />;
    }

    let style = setOriginalHeight ? { height: this.totalHeight } : {};
    
    return (
      <div className="my-project-tasks-new">
        {animator}
        <div className="my-project-header-new">
          <div className="project-name">{project.name.toUpperCase()}</div>
          <div className="right-side" onClick={expanded || setOriginalHeight ? this.handleContract : this.handleExpand}>
            {expanded || setOriginalHeight ? <div className="contractor" /> : <div className="expandor" />}
          </div>
        </div>
        <div id={id} className="task-list" style={style}>
          {taskList}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    actionCableUpdate: state.main.actionCableUpdate,
    inProgress: state.main.inProgress,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    online: state.main.online,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(NewProjectTasks);



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/NewProjectsTasksContainer/ProjectTasks/index.js